
// import React, { useState } from 'react';
// import TextInput from './TextInput';
// import TextAreaInput from './TextAreaInput';
// import RadioInput from './RadioInput';
// import CheckboxInput from './CheckBoxInput';
// import RatingInput from './RatingInput';
// import DateInput from './DateInput';
// import SignatureInput from './Signatureinput';
// import GroupInput from './Groupinput';
// import ConditionalInput from './Conditionalinput';
// import ConditionWithDurationInput from './Conditionwithdurationinput';
// import TableInput from './Tableinput';
// import CalculatedInput from './Calculatedinput';
// import NavigationButtons from './NavigationButtons';
// import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
// import { useFormValidation } from './Hooks/useFormValidation';
// import styles from './DynamicFormRenderer.module.css';
// import SelectInput from './Selectinput';
// import { upload, deleteFiles } from '../../../../Config/api';


// const DynamicFormRenderer = ({
//     section,
//     data,
//     onUpdate,
//     onNext,
//     onBack,
//     isLastSection,
//     isSubmitting,
//     isSubmitted,
//     onEligibilityConfirm
// }) => {
//     const { errors, validateSection } = useFormValidation();
//     const [showConfirmation, setShowConfirmation] = useState(false);
//     const [showExclusionModal, setShowExclusionModal] = useState(false);

//     const handleNext = () => {
//         const isEligibilitySection = section.id === 'eligibility_criteria';

//         if (isEligibilitySection) {
//             const inclusionGroup = section.questions.find(q => q.id === 'inclusion_criteria');
//             const exclusionGroup = section.questions.find(q => q.id === 'exclusion_criteria');
//             const declaration = section.questions.find(q => q.id === 'investigator_declaration');

//             let isEligible = true;

//             if (inclusionGroup?.questions) {
//                 inclusionGroup.questions.forEach(question => {
//                     if (question.validation?.mustBeTrue && data[question.id] !== 'YES') {
//                         isEligible = false;
//                     }
//                 });
//             }

//             if (exclusionGroup?.questions) {
//                 exclusionGroup.questions.forEach(question => {
//                     if (question.validation?.mustBeFalse && data[question.id] !== 'NO') {
//                         isEligible = false;
//                     }
//                 });
//             }

//             if (declaration?.questions) {
//                 const eligibleQuestion = declaration.questions.find(q => q.id === 'subject_eligible');
//                 if (eligibleQuestion && data[eligibleQuestion.id] === 'NO') {
//                     isEligible = false;
//                 }
//             }

//             if (!isEligible) {
//                 setShowExclusionModal(true);
//                 return;
//             }

//             onNext();
//             return;
//         }

//         if (validateSection(section, data)) {
//             if (isLastSection) {
//                 setShowConfirmation(true);
//             } else {
//                 onNext();
//             }
//         }
//     };

//     const handleExclusionConfirm = () => {
//         setShowExclusionModal(false);
//         if (onEligibilityConfirm) {
//             onEligibilityConfirm(false);
//         }
//     };

//     const handleExclusionCancel = () => {
//         setShowExclusionModal(false);
//     };

//     const handleConfirmSubmit = () => {
//         setShowConfirmation(false);
//         onNext();
//     };

//     const handleCancelSubmit = () => {
//         setShowConfirmation(false);
//     };

//     const handleMultiSelect = (questionId, value, checked) => {
//         if (isSubmitted) return;

//         const current = data[questionId] || [];
//         const updated = checked ? [...current, value] : current.filter(v => v !== value);
//         onUpdate({ [questionId]: updated });
//     };

//     const handleSignatureUpload = async (questionId, signatureData) => {
//         try {
//             const blob = await fetch(signatureData).then(r => r.blob());
//             const file = new File([blob], `signature_${questionId}.png`, { type: 'image/png' });

//             const formData = new FormData();
//             formData.append('file', file);
//             formData.append('fieldId', questionId);

//             const response = await upload(formData);

//             if (response.data) {
//                 onUpdate({
//                     [questionId]: signatureData,
//                     [`${questionId}_url`]: response.data.url || response.data.filePath
//                 });
//             }

//             return response;
//         } catch (error) {
//             console.error('Error uploading signature:', error);
//             throw error;
//         }
//     };

//     const handleSignatureDelete = async (questionId) => {
//         try {
//             const fileUrl = data[`${questionId}_url`];

//             if (fileUrl) {
//                 await deleteFiles({
//                     fileUrl: fileUrl,
//                     fieldId: questionId
//                 });
//             }

//             onUpdate({
//                 [questionId]: null,
//                 [`${questionId}_url`]: null
//             });
//         } catch (error) {
//             console.error('Error deleting signature:', error);
//             throw error;
//         }
//     };

//     const shouldShowConditional = (question) => {
//         if (!question.conditionalLogic) return false;

//         const { condition, value } = question.conditionalLogic;
//         const conditionValue = data[condition];

//         return conditionValue === value;
//     };

//     const renderQuestion = (question, index) => {
//         const value = data[question.id];
//         const error = errors[question.id];

//         const commonProps = {
//             question,
//             index,
//             value,
//             error,
//             isSubmitted,
//             data
//         };

//         switch (question.type) {
//             case 'text':
//                 return (
//                     <TextInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'number':
//                 return (
//                     <TextInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'textarea':
//                 return (
//                     <TextAreaInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'date':
//                 return (
//                     <DateInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'select':
//                 return (
//                     <SelectInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'radio':
//                 return (
//                     <RadioInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                         onOtherChange={(val) => onUpdate({ [`${question.id}_other`]: val })}
//                     />
//                 );

//             case 'checkbox':
//                 return (
//                     <CheckboxInput
//                         key={question.id}
//                         {...commonProps}
//                         onMultiSelect={handleMultiSelect}
//                     />
//                 );

//             case 'rating':
//                 return (
//                     <RatingInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             case 'signature':
//                 return (
//                     <SignatureInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => handleSignatureUpload(question.id, val)}
//                         onClear={() => handleSignatureDelete(question.id)}
//                     />
//                 );

//             case 'calculated':
//                 return (
//                     <CalculatedInput
//                         key={question.id}
//                         {...commonProps}
//                         allData={data}
//                     />
//                 );

//             case 'group':
//                 return (
//                     <GroupInput
//                         key={question.id}
//                         {...commonProps}
//                         onUpdate={onUpdate}
//                         renderQuestion={renderQuestion}
//                     />
//                 );

//             case 'conditional':
//                 if (!shouldShowConditional(question)) {
//                     return null;
//                 }
//                 return (
//                     <ConditionalInput
//                         key={question.id}
//                         {...commonProps}
//                         onUpdate={onUpdate}
//                         renderQuestion={renderQuestion}
//                         shouldShow={shouldShowConditional(question)}
//                     />
//                 );

//             case 'condition_with_duration':
//                 return (
//                     <ConditionWithDurationInput
//                         key={question.id}
//                         {...commonProps}
//                         onChange={(val) => onUpdate({ [question.id]: val })}
//                     />
//                 );

//             default:
//                 if (question.questions && typeof question.questions === 'object' && question.questions.columns) {
//                     return (
//                         <TableInput
//                             key={question.id}
//                             {...commonProps}
//                             onUpdate={onUpdate}
//                             shouldShow={shouldShowConditional(question)}
//                         />
//                     );
//                 }
//                 return null;
//         }
//     };

//     return (
//         <div className={styles.container}>
//             <div className={styles.formCard}>
//                 <div className={styles.sectionHeader}>
//                     <h2 className={styles.sectionTitle}>{section.title}</h2>
//                     {section.description && (
//                         <p className={styles.sectionDescription}>{section.description}</p>
//                     )}
//                 </div>

//                 <div className={styles.questionsContainer}>
//                     {section.questions.map((question, index) => renderQuestion(question, index))}
//                 </div>

//                 <NavigationButtons
//                     onBack={onBack}
//                     onNext={handleNext}
//                     isLastSection={isLastSection}
//                     isSubmitting={isSubmitting}
//                     isSubmitted={isSubmitted}
//                 />
//             </div>

//             <ConfirmationModal
//                 show={showExclusionModal}
//                 onConfirm={handleExclusionConfirm}
//                 onCancel={handleExclusionCancel}
//                 title="⚠️ Confirm Exclusion"
//                 message="Are you sure you want to mark this subject as Excluded from the study? This action will update the subject's status and restrict further data entry. You may continue only if the exclusion is appropriate and documented."
//                 confirmText="Confirm"
//                 cancelText="Cancel"
//                 type="warning"
//             />

//             <ConfirmationModal
//                 show={showConfirmation}
//                 onConfirm={handleConfirmSubmit}
//                 onCancel={handleCancelSubmit}
//             />
//         </div>
//     );
// };

// export default DynamicFormRenderer;

import React, { useState, useEffect } from 'react';
import TextInput from './TextInput';
import TextAreaInput from './TextAreaInput';
import RadioInput from './RadioInput';
import CheckboxInput from './CheckBoxInput';
import RatingInput from './RatingInput';
import DateInput from './DateInput';
import SignatureInput from './Signatureinput';
import GroupInput from './Groupinput';
import ConditionalInput from './Conditionalinput';
import ConditionWithDurationInput from './Conditionwithdurationinput';
import TableInput from './Tableinput';
import CalculatedInput from './Calculatedinput';
import NavigationButtons from './NavigationButtons';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import { useFormValidation } from './Hooks/useFormValidation';
import styles from './DynamicFormRenderer.module.css';
import SelectInput from './Selectinput';
import { upload, deleteFiles } from '../../../../Config/api';

const DynamicFormRenderer = ({
    section,
    data,
    onUpdate,
    onNext,
    onBack,
    isLastSection,
    isSubmitting,
    isSubmitted,
    onEligibilityConfirm
}) => {
    const { errors, validateSection } = useFormValidation();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showExclusionModal, setShowExclusionModal] = useState(false);
    const [conditionalFieldsVisibility, setConditionalFieldsVisibility] = useState({});

    useEffect(() => {
        const declarationGroup = section.questions?.find(q => q.id === 'investigator_declaration');
        if (declarationGroup?.questions) {
            const subjectEligibleField = declarationGroup.questions.find(q => q.id === 'subject_eligible');
            if (subjectEligibleField?.onChange) {
                const shouldShowReason = data['subject_eligible'] === 'NO';
                setConditionalFieldsVisibility(prev => ({
                    ...prev,
                    'reason_exclusion': shouldShowReason
                }));
            }
        }
    }, [data, section]);

    const handleNext = () => {
        const isEligibilitySection = section.id === 'eligibility_criteria';

        if (isEligibilitySection) {
            const inclusionGroup = section.questions.find(q => q.id === 'inclusion_criteria');
            const exclusionGroup = section.questions.find(q => q.id === 'exclusion_criteria');
            const declaration = section.questions.find(q => q.id === 'investigator_declaration');

            let isEligible = true;

            if (inclusionGroup?.questions) {
                inclusionGroup.questions.forEach(question => {
                    if (question.validation?.mustBeTrue && data[question.id] !== 'YES') {
                        isEligible = false;
                    }
                });
            }

            if (exclusionGroup?.questions) {
                exclusionGroup.questions.forEach(question => {
                    if (question.validation?.mustBeFalse && data[question.id] !== 'NO') {
                        isEligible = false;
                    }
                });
            }

            if (declaration?.questions) {
                const eligibleQuestion = declaration.questions.find(q => q.id === 'subject_eligible');
                if (eligibleQuestion && data[eligibleQuestion.id] === 'NO') {
                    isEligible = false;
                }
            }

            if (!isEligible) {
                setShowExclusionModal(true);
                return;
            }

            onNext();
            return;
        }

        if (validateSection(section, data)) {
            if (isLastSection) {
                setShowConfirmation(true);
            } else {
                onNext();
            }
        }
    };

    const handleExclusionConfirm = () => {
        setShowExclusionModal(false);
        if (onEligibilityConfirm) {
            onEligibilityConfirm(false);
        }
    };

    const handleExclusionCancel = () => {
        setShowExclusionModal(false);
    };

    const handleConfirmSubmit = () => {
        setShowConfirmation(false);
        onNext();
    };

    const handleCancelSubmit = () => {
        setShowConfirmation(false);
    };

    const handleMultiSelect = (questionId, value, checked) => {
        if (isSubmitted) return;

        const current = data[questionId] || [];
        const updated = checked ? [...current, value] : current.filter(v => v !== value);
        onUpdate({ [questionId]: updated });
    };

    const handleSignatureUpload = async (questionId, signatureData) => {
        try {
            const blob = await fetch(signatureData).then(r => r.blob());
            const file = new File([blob], `signature_${questionId}.png`, { type: 'image/png' });

            const formData = new FormData();
            formData.append('file', file);
            formData.append('fieldId', questionId);

            const response = await upload(formData);

            if (response.data) {
                onUpdate({
                    [questionId]: signatureData,
                    [`${questionId}_url`]: response.data.url || response.data.filePath
                });
            }

            return response;
        } catch (error) {
            console.error('Error uploading signature:', error);
            throw error;
        }
    };

    const handleSignatureDelete = async (questionId) => {
        try {
            const fileUrl = data[`${questionId}_url`];

            if (fileUrl) {
                await deleteFiles({
                    fileUrl: fileUrl,
                    fieldId: questionId
                });
            }

            onUpdate({
                [questionId]: null,
                [`${questionId}_url`]: null
            });
        } catch (error) {
            console.error('Error deleting signature:', error);
            throw error;
        }
    };

    const shouldShowConditional = (question) => {
        if (!question.conditionalLogic) return false;

        const { condition, value } = question.conditionalLogic;
        const conditionValue = data[condition];

        return conditionValue === value;
    };

    const renderQuestion = (question, index) => {
        if (question.id === 'reason_exclusion' && !conditionalFieldsVisibility['reason_exclusion']) {
            return null;
        }

        const value = data[question.id];
        const error = errors[question.id];

        const commonProps = {
            question,
            index,
            value,
            error,
            isSubmitted,
            data
        };

        switch (question.type) {
            case 'text':
                return (
                    <TextInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'number':
                return (
                    <TextInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'textarea':
                return (
                    <TextAreaInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'date':
                return (
                    <DateInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'select':
                return (
                    <SelectInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'radio':
                return (
                    <RadioInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                        onOtherChange={(val) => onUpdate({ [`${question.id}_other`]: val })}
                    />
                );

            case 'checkbox':
                return (
                    <CheckboxInput
                        key={question.id}
                        {...commonProps}
                        onMultiSelect={handleMultiSelect}
                    />
                );

            case 'rating':
                return (
                    <RatingInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            case 'signature':
                return (
                    <SignatureInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => handleSignatureUpload(question.id, val)}
                        onClear={() => handleSignatureDelete(question.id)}
                    />
                );

            case 'calculated':
                return (
                    <CalculatedInput
                        key={question.id}
                        {...commonProps}
                        allData={data}
                    />
                );

            case 'group':
                return (
                    <GroupInput
                        key={question.id}
                        {...commonProps}
                        onUpdate={onUpdate}
                        renderQuestion={renderQuestion}
                    />
                );

            case 'conditional':
                return (
                    <ConditionalInput
                        key={question.id}
                        {...commonProps}
                        onUpdate={onUpdate}
                        renderQuestion={renderQuestion}
                        shouldShow={true}
                    />
                );

            case 'condition_with_duration':
                return (
                    <ConditionWithDurationInput
                        key={question.id}
                        {...commonProps}
                        onChange={(val) => onUpdate({ [question.id]: val })}
                    />
                );

            default:
                if (question.questions && typeof question.questions === 'object' && question.questions.columns) {
                    return (
                        <TableInput
                            key={question.id}
                            {...commonProps}
                            onUpdate={onUpdate}
                            shouldShow={shouldShowConditional(question)}
                        />
                    );
                }
                return null;
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.formCard}>
                <div className={styles.sectionHeader}>
                    <h2 className={styles.sectionTitle}>{section.title}</h2>
                    {section.description && (
                        <p className={styles.sectionDescription}>{section.description}</p>
                    )}
                </div>

                <div className={styles.questionsContainer}>
                    {section.questions.map((question, index) => renderQuestion(question, index))}
                </div>

                <NavigationButtons
                    onBack={onBack}
                    onNext={handleNext}
                    isLastSection={isLastSection}
                    isSubmitting={isSubmitting}
                    isSubmitted={isSubmitted}
                />
            </div>

            <ConfirmationModal
                show={showExclusionModal}
                onConfirm={handleExclusionConfirm}
                onCancel={handleExclusionCancel}
                title=" Confirm Exclusion"
                message="The subject does not meet the inclusion criteria and must be excluded as per protocol. Do you want to proceed?"
                confirmText="Confirm"
                cancelText="Cancel"
                type="warning"
            />

            <ConfirmationModal
                show={showConfirmation}
                onConfirm={handleConfirmSubmit}
                onCancel={handleCancelSubmit}
            />
        </div>
    );
};

export default DynamicFormRenderer;